// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xProductPartNumbersStyles from "@conklin/App/SharedStyles/ProductPartNumbersStyles";
import { skuNumberStyles } from "@conklin/App/Widgets/ProductDetails/ProductDetailsSkuNumber";
import { css } from "styled-components";

skuNumberStyles.labelText = {
    ...xProductPartNumbersStyles.label,
    css: css`
        ${xProductPartNumbersStyles.label?.css}
        font-size: 14px;
        line-height: 17px;
    `,
};
skuNumberStyles.valueText = {
    ...xProductPartNumbersStyles.value,
    css: css`
        ${xProductPartNumbersStyles.value?.css}
        font-size: 14px;
        line-height: 17px;
    `,
};

skuNumberStyles.wrapper = {
    css: css`
        display: flex;
    `,
};
